<div
  class="spark-tags-container"
  #tagsContainer
  [style.justifyContent]="alignRight ? 'flex-end' : 'flex-start'"
>
  <div class="spark-tags-visible">
    <span
      *ngFor="let tag of visibleTags"
      class="spark-tag"
      [style.backgroundColor]="tag.color?.background"
      [style.color]="tag.color?.text"
      [style.borderColor]="tag.color?.border"
    >
      {{ tag.name }}
    </span>
  </div>
  <div
    class="spark-tags-ellipsis-container"
    *ngIf="hasHiddenTags"
    id="overflow-ellipsis"
  >
    <span class="spark-tags-ellipsis gpd-selectable">...</span>
    <dx-popover
      [target]="'#overflow-ellipsis'"
      showEvent="mouseenter"
      hideEvent="mouseleave"
      [wrapperAttr]="{ class: 'gpd-popover' }"
    >
      <div class="spark-tags-popover-content">
        <span
          *ngFor="let tag of hiddenTags"
          class="spark-tag popover-tag"
          [style.backgroundColor]="tag.color?.background"
          [style.color]="tag.color?.text"
          [style.borderColor]="tag.color?.border"
        >
          {{ tag.name }}
        </span>
      </div>
    </dx-popover>
  </div>
</div>
